import { useLocation } from 'react-router-dom';

interface ViewProps {
    isDetailPage: boolean;
}

const useRakindaDetail = (): ViewProps => {
    const { pathname } = useLocation();

    return {
        isDetailPage: pathname.includes('detail') && pathname.includes('rakinda')
    };
};

export default useRakindaDetail;
